import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Chip } from '@material-ui/core';
import { common, red } from '@material-ui/core/colors';
import { createStyles, makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      background: red[900],
      color: common.white,
      padding: '20px 32px',
    },
    heading: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 12,
      marginBottom: 4,
    },
    chip: {
      background: common.white,
      color: red[900],
      fontWeight: 700,
    },
    title: {
      fontSize: 22,
      fontWeight: 700,
    },
    message: {
      opacity: 0.9,
      '& strong': {
        fontWeight: 700,
      },
    },
  })
);

const DeprecationBar: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div role="alert" className={classes.root}>
      <div className={classes.heading}>
        <Chip label={t('bulkMessaging.deprecatedChip')} size="small" className={classes.chip} />
        <span className={classes.title}>{t('bulkMessaging.deprecatedTitle')}</span>
      </div>
      <div className={classes.message}>
        <Trans i18nKey="bulkMessaging.deprecated" components={{ 1: <strong /> }} />
      </div>
    </div>
  );
};

export default DeprecationBar;
